import { useEffect, useState } from "react";
import { ShieldAlert, Send, ShieldCheck } from "lucide-react";
import { registerComplianceHost } from "../lib/compliance";

export const ComplianceDialogHost = () => {
  const [req, setReq] = useState(null);
  const [reason, setReason] = useState("");
  useEffect(() => { registerComplianceHost((r) => { setReason(""); setReq(r); }); return () => registerComplianceHost(null); }, []);
  if (!req) return null;
  const close = (choice) => { req.resolve(choice); setReq(null); };
  const primary = req.is_primary_admin;
  const tooShort = !primary && reason.trim().length < 5;
  return (
    <div className="fixed inset-0 z-[70] bg-slate-900/50 backdrop-blur-sm grid place-items-center p-4">
      <div data-testid="compliance-dialog" className="bg-white rounded-md w-full max-w-lg border border-rose-200 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-rose-100 bg-rose-50 flex items-center gap-2">
          <ShieldAlert className="h-5 w-5 text-rose-600" />
          <h3 className="font-display text-lg font-bold text-rose-900">Règles de conformité non respectées</h3>
        </div>
        <div className="p-5 space-y-4">
          <ul className="space-y-2" data-testid="compliance-violations">
            {req.violations.map((v, i) => (
              <li key={i} className="text-sm border-l-4 border-rose-500 pl-3"><div className="font-semibold">{v.label}</div><div className="text-slate-600">{v.detail}</div></li>
            ))}
          </ul>
          <p className="text-xs text-slate-500">
            {primary ? "En tant qu'administrateur principal, vous pouvez passer outre. L'action sera tracée dans le journal d'audit."
                     : "Cette affectation est bloquée. Vous pouvez envoyer une demande motivée à l'administrateur principal pour validation."}
          </p>
          <textarea data-testid="compliance-reason" className="input h-24" value={reason} onChange={(e) => setReason(e.target.value)}
                    placeholder={primary ? "Motif (facultatif) : accord spécifique, vacation 24h, urgence…" : "Motif de la demande (obligatoire)"} />
        </div>
        <div className="px-5 py-4 border-t border-slate-100 flex justify-end gap-2">
          <button data-testid="compliance-cancel-btn" onClick={() => close(null)} className="px-4 py-2 text-sm rounded-md border border-slate-300 hover:bg-slate-50">Annuler</button>
          {primary
            ? <button data-testid="compliance-override-btn" onClick={() => close({ action: "override", reason })} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-md bg-rose-600 text-white hover:bg-rose-700"><ShieldCheck className="h-4 w-4" />Passer outre</button>
            : <button data-testid="compliance-request-btn" disabled={tooShort} onClick={() => close({ action: "request", reason })} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-md text-white hover:opacity-90 disabled:opacity-50" style={{ backgroundColor: "var(--brand-primary)" }}><Send className="h-4 w-4" />Envoyer la demande</button>}
        </div>
      </div>
    </div>
  );
};
